import { apiClient } from "../lib/api";

export const workCalendarApi = {
  listCalendars: () => apiClient.get("/settings/work-calendars"),
  createCalendar: (payload) => apiClient.post("/settings/work-calendars", payload),
  getCalendar: (id) => apiClient.get(`/settings/work-calendars/${id}`),
  getClassification: (storeLocation, date) => apiClient.get("/settings/work-calendars/classification", { params: { store_location: storeLocation || undefined, date } }),

  listAssignments: () => apiClient.get("/settings/work-calendars/assignments"),
  assignCalendar: (payload) => apiClient.post("/settings/work-calendars/assignments", payload),

  listVersions: (calendarId) => apiClient.get(`/settings/work-calendars/${calendarId}/versions`),
  createVersion: (calendarId, payload) => apiClient.post(`/settings/work-calendars/${calendarId}/versions`, payload),
  getVersion: (versionId) => apiClient.get(`/settings/work-calendars/versions/${versionId}`),
  submitVersion: (versionId) => apiClient.post(`/settings/work-calendars/versions/${versionId}/submit`),
  approveVersion: (versionId) => apiClient.post(`/settings/work-calendars/versions/${versionId}/approve`),
  rejectVersion: (versionId, reason) => apiClient.post(`/settings/work-calendars/versions/${versionId}/reject`, { reason }),

  importDays: (versionId, dates) => apiClient.post(`/settings/work-calendars/versions/${versionId}/days/import`, { dates }),
  classifyDay: (versionId, date, classification, notes) => apiClient.post(`/settings/work-calendars/versions/${versionId}/days/classify`, { date, classification, notes }),
  listDays: (versionId) => apiClient.get(`/settings/work-calendars/versions/${versionId}/days`),
};
